import dayjs, { Dayjs } from 'dayjs';

import { SiteType } from '../../../graphql/types/SiteType';
import { WarehouseData } from '../../../contexts/WarehouseContext';
import { GetTikTokExceptionReportOrdersVariables } from './graphql/getTikTokExceptionReportOrders';

export const DEFAULT_PAGE_SIZE = 20;
export const MAX_TRACKING_NUMBER_FILTER_COUNT = 100;

export interface TikTokExceptionOrderFilterState {
    createdAtRange: [Dayjs, Dayjs];
    trackingNumbers: string[];
    exceptionReasonCode: string;
}

export const createDefaultTikTokExceptionOrderFilters = (
    now: Dayjs = dayjs(),
): TikTokExceptionOrderFilterState => ({
    createdAtRange: [now.subtract(6, 'day').startOf('day'), now],
    trackingNumbers: [],
    exceptionReasonCode: '',
});

export const canQueryTikTokExceptionOrders = (
    hasPermission: boolean,
    warehouse: WarehouseData | null,
): boolean => hasPermission && warehouse?.siteType === SiteType.HUB && Number(warehouse.id) > 0;

export const buildTikTokExceptionOrderVariables = (
    warehouseId: number,
    filters: TikTokExceptionOrderFilterState,
    page: number,
    size: number,
): GetTikTokExceptionReportOrdersVariables => {
    const trackingNumbers = Array.from(new Set(
        filters.trackingNumbers.map((value) => value.trim()).filter(Boolean),
    ));
    const exceptionReasonCode = filters.exceptionReasonCode.trim();

    return {
        warehouseId,
        filters: {
            createdAtFrom: filters.createdAtRange[0].unix(),
            // 页面区间为闭区间，后端契约的终点为开区间。
            createdAtTo: filters.createdAtRange[1].add(1, 'second').unix(),
            ...(trackingNumbers.length > 0 ? { trackingNumbers } : {}),
            ...(exceptionReasonCode ? { exceptionReasonCode } : {}),
        },
        pageRequest: { page, size },
    };
};

export const getSafeHttpUrl = (rawUrl: string | null | undefined): string | null => {
    const value = rawUrl?.trim();
    if (!value) return null;

    try {
        const url = new URL(value);
        return url.protocol === 'http:' || url.protocol === 'https:' ? url.toString() : null;
    } catch {
        return null;
    }
};

export const openSafeHttpUrl = (rawUrl: string | null | undefined): boolean => {
    const safeUrl = getSafeHttpUrl(rawUrl);
    if (!safeUrl) return false;

    const opened = window.open(safeUrl, '_blank', 'noopener,noreferrer');
    if (opened) opened.opener = null;
    return true;
};
